export default __webpack_public_path__ + "static/media/avatar.67ad2e0d.svg";